import { useEffect, useState, useMemo } from "react"
import { Link } from 'react-router-dom'
import { Button, Table, Space, Upload, message } from 'antd'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from "../../js/permission"
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { apiPrefix } from '../../js/config'
import Cookie from 'js-cookie'

let uploadApi = apiPrefix + '/cooking/price/import'

const { Column } = Table
export default function() {
    const permission: string[] = useMemo(() => getPermission(), 
    [window.location.pathname])
    // 获取价格管理列表
    const [priceList, setPriceList] = useState([])
    const [loading, setLoading] = useState(false)

    const fetch = () => {
        
        axiosTable.get('/cooking/price/list', {}).then((response: any) => {
            setLoading(false)
            setPriceList([])
            if(response && response.length) {
                setPriceList(response)
            }
        }).catch(() => {
            setLoading(false)
        })
    } 

    const beforeUpload= (file : any) => {
        let result = (file.name.split('.'))[1]
        const isJpgOrPng = result === 'xls' || result === 'xlsx';
        if (!isJpgOrPng) {
          message.error('请上传正确的价格模板文件!');
        }
        return isJpgOrPng;
    }

    const onUploadChange = (val: any) => {
        const { response } = val.file
        if(response && response.status == 0) {
            message.success('导入成功')
            setLoading(true)
            fetch()
        }
    }

    useEffect(() => {
        setLoading(true)
        fetch()
    }, [])

    return (
        <div className="common-page">
            <BreadCrumb position={['膳食中心', '价格管理']} />
            <div className="common-top-form">
                {/* <Button type="primary" onClick={() => {

                }}>批量导入价格文件</Button> */}
                <Upload
                    name="files"
                    showUploadList={false}
                    action={uploadApi}
                    headers={
                       {
                        'token': Cookie.get('token') as any
                       }
                    }
                    beforeUpload={beforeUpload}
                    onChange={onUploadChange}
                >
                    <Button type="primary" >批量导入价格文件</Button>
                </Upload>
            </div>
            <div className="common-main">
                <Table
                    loading={loading}
                    pagination={false}
                    dataSource={priceList} 
                    bordered={true} 
                    rowKey="price_id" 
                >
                    <Column title="序号" dataIndex="index" key="index" render={(text, record, index) => index+ 1}/>
                    <Column title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="更新时间" dataIndex="update_time" key="update_time" />
                    <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => {
                            return (
                                <Space size="middle">
                                    {/* <Link to="/set_price" state={{record}}>设置价格</Link> */}
                                    <Link to={{pathname: '/set_price', state: {...record}}}>设置价格 </Link>
                                    {/* {permission.includes('设置价格') && (
                                        // <Button type="primary" 
                                        //     onClick={()=>{}}>
                                        //     设置价格
                                        // </Button>
                                        <Link to="/set_price">设置价格</Link>
                                    )} */}
                                </Space>
                            )
                        }}
                    />
                </Table>
            </div>
        </div>
    )
}